export const CURRENCY_CODES = {
  "643": {
    code: "RUB",
    symbol: "₽",
    name: "Russian Ruble",
  },
  "₽": {
    code: "RUB",
    symbol: "₽",
    name: "Russian Ruble",
  },
} as const;

export const formatCurrency = (amount: number, currencyCode: string) => {
  const currency = CURRENCY_CODES[currencyCode as keyof typeof CURRENCY_CODES];

  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: currency.code,
    minimumFractionDigits: 2,
  }).format(amount);
};
 